import { Slide } from "packages/lesson/dist/@types";
import config from "appConfig";

import theory from "../../theory";

const principle: Slide = {
  title: "",
  description:
    "In this principle you can test out the bark scale for yourself. Does the jump from 200 Hz to 300 Hz feel as significant to you as the jump from 6400 Hz to 6500 Hz?",
  theory: theory,
  layout: {
    type: "table",
    options: {
      cols: 4,
      rows: 2,
      colSpan: { "1:0": 4 },
      rowsSize: [1, 10],
      colsSize: [2, 2, 2, 3],
      components: [
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "audioButton",
                options: {
                  text: "0.2-0.3&nbsp;kHz",
                  size: "large",
                  icon: "cil-volume",
                  theme: "primary",
                  shape: "round",
                  url: `${config.ASSETS_URL}/02/03/principle/200Hz.wav`,
                  styles: {
                    marginLeft: "5vw",
                    minWidth: "11em",
                  },
                },
              },
            },
          },
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "audioButton",
                options: {
                  text: "0.3-0.4 kHz",
                  size: "large",
                  icon: "cil-volume",
                  theme: "primary",
                  shape: "round",
                  url: `${config.ASSETS_URL}/02/03/principle/300Hz.wav`,
                  styles: {
                    marginLeft: "5vw",
                    minWidth: "11em",
                  },
                },
              },
            },
          },
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "audioButton",
                options: {
                  text: "6.3-6.4 kHz",
                  size: "large",
                  icon: "cil-volume",
                  theme: "primary",
                  shape: "round",
                  url: `${config.ASSETS_URL}/02/03/principle/6400Hz.wav`,
                  styles: {
                    minWidth: "11em",
                  },
                },
              },
            },
          },
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "audioButton",
                options: {
                  text: "6.4-6.5 kHz",
                  size: "large",
                  icon: "cil-volume",
                  theme: "primary",
                  shape: "round",
                  url: `${config.ASSETS_URL}/02/03/principle/6500Hz.wav`,
                  styles: {
                    marginRight: "13vw",
                    minWidth: "11em",
                  },
                },
              },
            },
          },
        ],
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "image",
                options: {
                  src: `${config.ASSETS_URL}/02/03/principle/bark-bands.svg`,
                },
              },
            },
          },
        ],
      ],
    },
  },
};

export default principle;
